export class Branding {
  branding_id: number;
  tenant_id: number;
  domain: string;
  title: string;
  logo: string;
  footer: string;
}